import { Select } from "@omnia/shared/react/Select";
import { GenericProps } from "../../types";
import { groupings } from "./groupings";
import { GroupingKey } from "./types";
import { UsersFilter } from "../UsersFilter";

const groupingOptions = groupings.map(g => [g.key, g.name] as const)

export function CroppingFilters(props: GenericProps) {

    const { state, dispatch } = props

    function setGrouping(grouping: GroupingKey) {
        dispatch({
            type: "setCroppingGrouping",
            payload: grouping
        })
    }

    return <div className="flex-row">

        <div className="material-form">
            <Select
                value={state.cropping.grouping}
                options={groupingOptions}
                setValue={setGrouping}
            />
        </div>

        <UsersFilter {...props} />

    </div>

}